import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as non-blocking: when it fails, the interceptor swallows the
 * error and emits an empty response instead of propagating it. Use for
 * non-critical endpoints (e.g. weather) whose failure must not interrupt the
 * cash register flow / route resolvers.
 */
export const NON_BLOCKING = new HttpContextToken<boolean>(() => false);

/**
 * Returns an HttpContext flagged as non-blocking. Pass an existing context to
 * preserve other tokens.
 */
export function nonBlocking(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(NON_BLOCKING, true);
}
